const CONFIG = {
  argentina: { countryCode: 'AR', languageTag: 'es-AR', locale: 'es-AR', currency: 'ARS' },
  ar: { countryCode: 'AR', languageTag: 'es-AR', locale: 'es-AR', currency: 'ARS' },
  uruguay: { countryCode: 'UY', languageTag: 'es-UY', locale: 'es-UY', currency: 'UYU' },
  uy: { countryCode: 'UY', languageTag: 'es-UY', locale: 'es-UY', currency: 'UYU' },
  chile: { countryCode: 'CL', languageTag: 'es-CL', locale: 'es-CL', currency: 'CLP' },
  cl: { countryCode: 'CL', languageTag: 'es-CL', locale: 'es-CL', currency: 'CLP' }
};

const DEFAULT_CONFIG = CONFIG.argentina;

const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const getSeoCountry = (country) => CONFIG[normalize(country)] || DEFAULT_CONFIG;

export const getSeoCurrency = ({ country, explicitCurrency, priceUsd, sellInLocal = true }) => {
  const explicit = String(explicitCurrency || '').toUpperCase();
  if (['ARS', 'UYU', 'CLP', 'USD'].includes(explicit)) return explicit;
  if (Number(priceUsd) > 0 && sellInLocal === false) return 'USD';
  return getSeoCountry(country).currency;
};

export const getSeoPrice = (item, country) => {
  const currency = getSeoCurrency({
    country: item?.country || country,
    explicitCurrency: item?.currency,
    priceUsd: item?.price_usd,
    sellInLocal: item?.sell_in_local
  });
  return { currency, price: currency === 'USD' ? item?.price_usd : item?.price };
};

export const getLanguageAlternates = (url, country) => ({
  [getSeoCountry(country).languageTag]: url
});
